"use client";

import { useRef } from "react";
import posthog from "posthog-js";
import { useAppConfig } from "@/providers/app-config-provider";
import {
  _setCaptureEnabled,
  _setCaptureEnvironment,
} from "@/lib/analytics/client";
import { resolveEnvironment } from "@/lib/analytics/env";
import type { ReactNode } from "react";

export function PostHogProvider({ children }: { children: ReactNode }) {
  const {
    posthogEnabled,
    posthogProjectToken,
    posthogHost,
    appEnv,
    appDomain,
  } = useAppConfig();
  const initialized = useRef(false);

  if (typeof window !== "undefined" && !initialized.current) {
    _setCaptureEnabled(posthogEnabled);
    _setCaptureEnvironment(resolveEnvironment(appEnv));
    if (posthogEnabled && posthogProjectToken) {
      posthog.init(posthogProjectToken, {
        api_host: posthogHost,
        defaults: "2026-01-30",
        autocapture: false,
        session_recording: {
          maskAllInputs: true,
          maskTextSelector: "[data-ph-no-capture]",
        },
        // Auto-inject tracing headers on same-origin requests so server
        // route handlers can correlate $exception events with the browser
        // session replay. `apiClient` also sets the headers manually as a
        // fallback — see src/services/api.ts.
        __add_tracing_headers: [appDomain],
      });
    }
    initialized.current = true;
  }

  return <>{children}</>;
}
